import React, { useEffect } from "react";
import { IntroWrapper } from "../ui/IntroWrapper";
import { Footer } from "../components/footer";
import { FooterLogo } from "../assets/footerLogo";
import { useNavigate } from "react-router-dom";
import { ThankYouCard } from "../ui/ThankYouCard";
import { useTranslation } from "react-i18next";

export const BookedPage = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (i18n.language !== "us") {
        navigate(`/${i18n.language}`);
      } else {
        navigate("/");
      }
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate, i18n.language]);

  return (
    <div className="font-sans flex flex-col gap-[100px]">
      <IntroWrapper>
        <div className="justify-items-center mt-[20px]">
          <div onClick={() => navigate("/")} className="cursor-pointer">
            <FooterLogo />
          </div>
        </div>
        <ThankYouCard />
      </IntroWrapper>
      <Footer />
    </div>
  );
};
